import { routineDataWorkflowList, routineEndpointWorkflowList } from "./routines-data-workflow"

const endpointFor = (endpoints, value) =>
  endpoints.find((item) => item.value === value)?.endpoint

const fieldsByWorkflow = {
  PrecosCalculadosWorkflow: { endDate: true, dateRange: true },
  LiquidezWorkflow: { endDate: true },
  PrecosAndadosWorkflow: { file: true },
  PrecosEventosListaWorkflow: { endDate: true, cetipList: true },
  PrecosListaCetipsWorkflow: { endDate: true, cetipList: true },
  PrecosProcessadosWorkflow: { endDate: true },
  PrecosTunelWorkflow: { endDate: true },
  PrecosValidacaoWorkflow: { endDate: true, cetipList: true },
  SpreadEmissaoWorkflow: { endDate: true },
  SpreadNegociadoWorkflow: { endDate: true },
  VolatilidadeCurvasWorkflow: { days: true },
  B3FundosNetV2Workflow: { prompt: "B3FundosNet" },
}

const defaultExecution = (service, definition, values) =>
  service.startRoutine(definition.endpoint, {
    data_referencia: values.date,
    ...(definition.fields?.days ? { qtde_dias: Number(values.days) || 90 } : {}),
    ...(definition.fields?.prompt && values.prompt ? { prompt: values.prompt } : {}),
  })

const workflowExecutions = {
  PrecosCalculadosWorkflow: (service, _definition, values) =>
    service.startCalculatedPrices(values.date, values.endDate),
  PrecosAndadosWorkflow: (service, _definition, values) =>
    service.sendFilePrecosAndadosWorkflow(values.date, values.fileType, values.file),
  LiquidezWorkflow: (service, _definition, values) =>
    service.startarLiquidezWorkflow(values.date, values.endDate),
  ClientePrecosLogWorkflow: (service, _definition, values) =>
    service.startarClientePrecosLogWorkflow(values.date),
  CurvasWorkflow: (service, _definition, values) =>
    service.startarCurvasWorkflow(values.date),
  CurvasV2Workflow: (service, _definition, values) =>
    service.startarCurvasV2Workflow(values.date),
  PrecosEventosFinanceirosWorkflow: (service, _definition, values) =>
    service.startarPrecosEventosFinanceirosWorkflow(values.date),
  PrecosEventosListaWorkflow: (service, _definition, values) =>
    service.startarPrecosEventosListaWorkflow(values.cetipList, values.date, values.endDate),
  PrecosListaCetipsWorkflow: (service, _definition, values) =>
    service.startarPrecosListaCetipsWorkflow(values.cetipList, values.date, values.endDate),
  PrecosProcessadosWorkflow: (service, _definition, values) =>
    service.startarPrecosProcessadosWorkflow(values.date, values.endDate),
  PrecosTunelWorkflow: (service, _definition, values) =>
    service.startarPrecosTunelWorkflow(values.date, values.endDate),
  PrecosValidacaoWorkflow: (service, _definition, values) =>
    service.startarPrecosValidacaoWorkflow(values.cetipList, values.date, values.endDate),
  SpreadsBrutosTratadosWorkflow: (service, _definition, values) =>
    service.startarSpreadsBrutosTratadosWorkflow(values.date),
  SpreadEmissaoWorkflow: (service, _definition, values) =>
    service.startarSpreadEmissaoWorkflow(values.date, values.endDate),
  SpreadNegociadoWorkflow: (service, _definition, values) =>
    service.startarSpreadNegociadoWorkflow(values.date, values.endDate),
  SpreadsNegociadosConsolidadosWorkflow: (service, _definition, values) =>
    service.startarSpreadsNegociadosConsolidadosWorkflow(values.date),
  TratamentoRiskFree: (service, _definition, values) =>
    service.startTratamentoRiskFreeV2(values.date),
  // B3FundosNetV2Workflow não precisa de executor próprio -- cai no
  // defaultExecution, que já sabe incluir "prompt" condicionalmente
  // (ver fieldsByWorkflow.B3FundosNetV2Workflow.prompt acima).
}

export const workflowRoutineDefinitions = [
  ...routineDataWorkflowList,
  { value: "PrecosCalculadosWorkflow", description: "Preços Calculados" },
]
  .filter((item) => !item.disabled)
  .map((item) => ({
    value: item.value,
    label: item.description,
    endpoint: endpointFor(routineEndpointWorkflowList, item.value),
    fields: fieldsByWorkflow[item.value] || {},
    allowRebuild: item.value === "VolatilidadeCurvasWorkflow",
    execute: workflowExecutions[item.value] || defaultExecution,
  }))

export const executeWorkflowRoutine = (service, definition, values) =>
  definition.execute(service, definition, values)

export const getRoutineErrorMessage = (error) => {
  const body = error?.response?.body || {}
  return (
    body.detail ||
    body.code ||
    error?.response?.text ||
    error?.message ||
    "Erro ao iniciar rotina"
  )
}